import * as React from "react";
import { forwardRef } from "react";
const SvgInbox = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.06055 3.24854H22.9395V20.7517H1.06055V3.24854Z", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1.06055 6.53027L12 13.094L22.9395 6.53027", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgInbox);
export { ForwardRef as ReactComponent };
